type RawUser = {
  id: string;
  email: string;
  name: string;
  status: string;
  role: string;
  tenants?: { id: string; name: string, role: string }[];
};

export function mapUser(user: RawUser, settings?:object) {
  return {
    id: user.id,
    email: user.email,
    name: user.name,
    role: user.role,
    status: user.status,
    tenants: user.tenants || [],
    from: 'jwt',
    data: {
      displayName: user.name,
      email: user.email,
      photoURL: 'https://e7.pngegg.com/pngimages/84/165/png-clipart-united-states-avatar-organization-information-user-avatar-service-computer-wallpaper.png',
      settings,
      shortcuts: ['calendar', 'mail', 'contacts', 'todo'],
    },
    isAdmin: user.role?.toLowerCase() === 'admin',
    isManager: user.role?.toLowerCase() === 'manager',
    isEmployee: user.role?.toLowerCase() === 'employee',
    isCustomer: user.role?.toLowerCase() === 'customer',
  };
}